import React, { FC } from 'react'
import { useSelector } from 'react-redux'

import projectSelectors from '../../store/selectors/project'

interface WithRoleProps {
  name: string,
  exclude?: string[],
}

const WithRole: FC<React.PropsWithChildren<WithRoleProps>> = ({
  name,
  exclude,
  children,
}) => {
  const summary = useSelector(projectSelectors.summary)
  if(!summary) return null
  const summaryRole = summary.roles[name]
  if(!summaryRole) return null
  const exludedRole = exclude ?
    exclude.find(name => summary.roles[name]) :
    null
  if(exludedRole) return null
  return (
    <>
      { children }
    </>
  )
}

export default WithRole